import React from 'react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
      <div className="max-w-4xl mx-auto px-4 py-16">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-black mb-6 text-[#e2b13c]">
            Patrick Blondel : L'art de vous conduire au cœur des Weppes
          </h1>
          <h2 className="text-2xl font-semibold text-white">
            Un partenaire de transport de confiance dans les Hauts-de-France
          </h2>
        </div>

        {/* Contenu */}
        <div className="bg-[#0f172a] border-2 border-[#e2b13c] rounded-lg p-10 text-gray-200 leading-relaxed">
          <div className="text-center mb-8">
            <div className="inline-block bg-[#e2b13c] text-[#0f172a] px-6 py-3 rounded-full font-bold text-lg">
              👋 Bienvenue à bord !
            </div>
          </div>

          <p className="text-lg mb-6">
            Je m'appelle <strong className="text-[#e2b13c]">Patrick</strong>, fondateur de <strong className="text-[#e2b13c]">VTC des Weppes</strong>. Après 12 années passées dans l'assistance médicale à domicile, j'ai conservé le goût du contact humain et le sens du service.
          </p>

          <p className="text-lg mb-6">
            Aujourd'hui chauffeur VTC professionnel, je mets ma passion de la conduite au service de votre confort et de votre sécurité. Mon objectif ? <strong className="text-[#e2b13c]">Être le facilitateur de vos déplacements avec le sourire</strong>.
          </p>

          <div className="my-10 h-1 bg-gradient-to-r from-transparent via-[#e2b13c] to-transparent"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            <div className="bg-[#1e293b] p-6 rounded-lg border border-[#e2b13c]">
              <h3 className="text-xl font-bold text-[#e2b13c] mb-3">🎯 Notre Mission</h3>
              <p className="text-gray-300">
                Vous offrir un service de transport premium basé sur la confiance, la ponctualité et le respect de vos besoins.
              </p>
            </div>
            <div className="bg-[#1e293b] p-6 rounded-lg border border-[#e2b13c]">
              <h3 className="text-xl font-bold text-[#e2b13c] mb-3">💼 Nos Valeurs</h3>
              <p className="text-gray-300">
                Professionnalisme, discrétion, bienveillance et engagement pour votre satisfaction à chaque trajet.
              </p>
            </div>
          </div>

          <div className="text-center mt-10">
            <p className="text-xl font-semibold text-[#e2b13c]">
              "L'humain avant l'algorithme"
            </p>
            <p className="text-gray-400 mt-2 italic">— Patrick Blondel, Fondateur</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;